import styled from 'styled-components';

interface ContainerProps {
  isViewMode: boolean;
}
const Container = styled.div<ContainerProps>`
  padding: ${props => props.isViewMode ? 0 : '30px 20px 20px 20px'};
  display: flex;
  flex-direction: column;
  border-left: ${props => props.isViewMode ? 0 : 1}px solid ${props => props.theme.color.background};
`;

const Price = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  height: 82px;
`;

const PriceCost = styled.div`
  margin-right: 20px;
  line-height: 50px;
  display: flex;
  flex-direction: column;
`;

const PrimaryPrice = styled.div`
  font-size: 36px;
  line-height: 41px;
  color: ${props => props.theme.color.mainFont};
`;

const ExtraPrice = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: ${props => props.theme.color.mainFont};
`;

const PriceDescription = styled.div`
  display: flex;
  flex-direction:column;
  justify-content: flex-end;
  padding-bottom: 7px;

  p {
    line-height: 16px;
  }
`;

export const Styled = {
  Container,
  Price,
  PriceCost,
  PrimaryPrice,
  ExtraPrice,
  PriceDescription,
};
